import { createContext, useContext } from "react";

const ThemeContext = createContext<KitTheme>({});

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
